<template>
  <a-modal
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    centered
    :destroyOnClose="true"
    :maskClosable="false"
    :width="515"
    :bodyStyle="{textAlign: 'center'}"
  >
    <div class="title">[VIP专享] 达梦工单服务</div>
    <div class="video_box video_bg">
      <video
        autoplay
        loop
        muted="muted"
        poster="https://lhcdn.lanhuapp.com/home/img/designer_slice_cover_new.png"
      >
        <source
          src="https://bcloud-alipic.lanhuapp.com/video/designer_slice_new.mp4"
          type="video/mp4"
        />
        浏览器版本太低，不支持本视频播放，请升级浏览器
      </video>
    </div>
    <div class="tips">
      如您在使用产品的过程中遇到技术问题，请点击个人头像，选择“我的工单”即可提交工单，工单处理更高效！
    </div>
    <a-button type="primary">了解更多</a-button>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      title: '[VIP专享]  达梦工单服务',
      visible: false,
    }
  },
  methods: {
    handleMore() {
      console.log(`了解更多...`)
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  line-height: 22px;
}
.tips {
  font-size: 14px;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-bottom: 23px;
}
.video_box {
  margin-top: 25px;
  margin-bottom: 16px;
}
</style>
